import { Box, customStyled, Flex } from '@mafc/trolly';
import MQ from 'theme/breakpoints';

export const Cart = customStyled(Flex)`
    padding: 14px
    ${MQ[3]} {
        padding: 0
    }
`;

export const LeftSide = customStyled(Box)`
    ${MQ[2]} {
        margin-right: 48px;
        width: 50%;
    }
`;
